import { calculateVisibleHeaderHeight } from "./visible-header-height"

;(function () {
    // Create MutationObserver callback to check for class "stuck" change
    const callback = function (mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.attributeName === "class") {
                const element = mutation.target
                const isStuck = element.classList.contains("stuck")

                // If stuck, add class "stuck" to html
                if (isStuck) {
                    document.documentElement.classList.add("header-stuck")
                } else {
                    document.documentElement.classList.remove("header-stuck")
                }

                calculateVisibleHeaderHeight()
            }
        }
    }

    // Create MutationObserver
    const observer = new MutationObserver(callback)

    // Get header element
    const header = document.querySelector(".header-wrapper")

    // Start observing header element
    observer.observe(header, { attributes: true, attributeFilter: ["class"] })
})()
